import React, { useState } from "react";
import { Tabs, Button, Drawer, Card} from "antd";
import { EyeOutlined } from "@ant-design/icons";
import CustomAgGrid, { ColumnDefinition } from "../../shared/AgGridClient";
import "./FkGeneratedInvoice.scss";
import invoiceData from "../../assets/JSON/QATAR_PAX_INVOICE.json";
import creditNoteData from "../../assets/JSON/QATAR_PAX_CREDIT_NOTE.json";
import PaxInvoiceRow1 from "../../assets/pdfs/pax_invoice_row1 (1).pdf";
import PaxInvoiceRow2 from "../../assets/pdfs/pax_invoice_row2 (1).pdf";
import PaxInvoiceRow3 from "../../assets/pdfs/pax_invoice_row3(1).pdf";
import PaxInvoiceRow4 from "../../assets/pdfs/pax_invoice_row4 (1).pdf";
import PaxInvoiceRow5 from "../../assets/pdfs/pax_invoice_row5.pdf";
import PaxInvoiceRow6 from "../../assets/pdfs/pax_invoice_row4.pdf";
import CreditNoteRow1 from "../../assets/pdfs/pax_credit_row1.pdf";
import CreditNoteRow2 from "../../assets/pdfs/pax_credit_row2.pdf";
import importDoData from "../../assets/JSON/QATAR_IMPORT_DO.json";
import ImportDoRow1 from "../../assets/pdfs/import_do_invoice_row1.pdf";
import ImportDoRow2 from "../../assets/pdfs/import_do_invoice_row2.pdf";
import ImportDoRow3 from "../../assets/pdfs/import_do_credit_row3.pdf";
import CargoRow1 from "../../assets/pdfs/cargo_invoice_row1.pdf";
import cargoData from "../../assets/JSON/QATAR_CARGO_1.json";

const { TabPane } = Tabs;

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
}

const StatCard: React.FC<StatCardProps> = ({ icon, label, value }) => {
    return (
      <Card className="stat-card">
        <div className="stat-inner">
          <div className={`stat-icon `}>{icon}</div>
          <div className="stat-content">
            <h3 className="stat-label">{label}</h3>
            <p className="stat-value">{value}</p>
          </div>
        </div>
      </Card>
    );
  };

  const INVOICE_PDF_MAP: Record<string, string> = {
    "2512KAAMD0000071": PaxInvoiceRow1,
    "2512MHAMD0000064": PaxInvoiceRow2,
    "2512MHAMD0000057": PaxInvoiceRow3,
    "2512GJAMD0000070": PaxInvoiceRow4,
    "2512WBAMD0000056": PaxInvoiceRow5,
    "2512MHAMD0000063": PaxInvoiceRow6, // import this pdf as well
  };
  
  // Credit Note PDF map (key = Credit Note No)
  const CREDIT_NOTE_PDF_MAP: Record<string, string> = {
    "2512MHAMD0000055": CreditNoteRow1,
    "2512GJAMD0000072": CreditNoteRow2,
  };

  const IMPORT_DO_PDF_MAP: Record<string, string> = {
    "2512DLINANF00052": ImportDoRow1,
    "2512DLINANF00152": ImportDoRow2,
    "2512DLINANFCN001": ImportDoRow3,
  };

  const CARGO_PDF_MAP: Record<string, string> = {
    "2512DLINANF00148": CargoRow1,
  };
  

  


const FkGeneratedInvoice: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const openDrawer = (row: any) => {
    setSelectedRow(row);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedRow(null);
  };



//   const commonColumns: ColumnDefinition[] = [
//     {
//       headerName: "Document ID",
//       field: "id",
//       sortable: true,
//       filter: true,
//     },
//     {
//       headerName: "Customer",
//       field: "customer",
//       sortable: true,
//       filter: true,
//     },
//     {
//       headerName: "Amount",
//       field: "amount",
//       sortable: true,
//     },
//     {
//       headerName: "Date",
//       field: "date",
//       sortable: true,
//     },
//     {
//       headerName: "Action",
//       field: "action",
//       width: 120,
//       cellRenderer: (params: any) => (
//         <Button
//           type="link"
//           icon={<EyeOutlined />}
//           onClick={() => openDrawer(params.data)}
//         >
//           View
//         </Button>
//       ),
//     },
//   ];

const invoiceColumns: ColumnDefinition[] = [
    {
      headerName: "Action",
      field: "action",
      width: 150,
      cellRenderer: (params: any) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => openDrawer(params.data)}
        >
          View
        </Button>
      ),
    },
    // {
    //     headerName: "Description",
    //     field: "description",
    //     width: 200,
    //     valueGetter: p => p.data["Description"],
    //   },
    // {
    //   headerName: "Airline Name",
    //   field: "airlineName",
    //   width: 150,
    //   valueGetter: p => p.data["Airline Name"],
    //   filter: true,
    // },
    // {
    //   headerName: "GSTIN of Supplier",
    //   field: "gstinSupplier",
    //   width: 150,
    //   valueGetter: p => p.data["GSTIN of Supplier"],
    // },
    // {
    //   headerName: "PAN",
    //   field: "pan",
    //   width: 150,
    //   valueGetter: p => p.data["PAN"],
    // },
    {
      headerName: "Invoice No",
      field: "invoiceNo",
      width: 150,
      valueGetter: p => p.data["Invoice No"],
      filter: true,
    },
    {
      headerName: "Invoice Date",
      field: "invoiceDate",
      width: 150,
      valueGetter: p => p.data["Invoice Date"],
    },
    {
      headerName: "Place of Supply",
      field: "placeOfSupply",
      width: 150,
      valueGetter: p => p.data["Place of Supply"],
    },
    // {
    //   headerName: "Reverse Charge",
    //   field: "reverseCharge",
    //   width: 150,
    //   valueGetter: p => p.data["Tax Is Payable On Reverse Charge: (Yes/No)"],
    // },
    {
      headerName: "Customer Name",
      field: "customerName",
      width: 200,
      valueGetter: p => p.data["Name"],
      filter: true,
    },
    {
      headerName: "State",
      field: "state",
      width: 200,
      valueGetter: p => p.data["State and State Code"],
    },
    {
      headerName: "Recipient GSTIN",
      field: "recipientGstin",
      width: 160,
      valueGetter: p => p.data["GSTIN/Unique ID of Recipient"],
    },
    // {
    //   headerName: "Ticket / Document No",
    //   field: "ticketNo",
    //   width: 150,
    //   valueGetter: p => p.data["Ticket/ Document Number"],
    // },
    // {
    //   headerName: "HSN",
    //   field: "hsn",
    //   width: 150,
    //   valueGetter: p => p.data["HSN"],
    // },
    // {
    //   headerName: "Total Value",
    //   field: "totalValue",
    //   width: 150,
    //   valueGetter: p => p.data["Total Value"],
    // },
    // {
    //   headerName: "Other Taxes",
    //   field: "otherTaxes",
    //   width: 150,
    //   valueGetter: p => p.data["Other Taxes"],
    // },
    // {
    //   headerName: "Taxable Value",
    //   field: "taxableValue",
    //   width: 150,
    //   valueGetter: p => p.data["Taxable Value"],
    // },
    // {
    //   headerName: "Tax %",
    //   field: "taxPercent",
    //   width: 150,
    //   valueGetter: p => p.data["Tax %"],
    // },
    // {
    //   headerName: "Tax Amount",
    //   field: "taxAmount",
    //   width: 150,
    //   valueGetter: p => p.data["Tax Amount"],
    // },
    {
      headerName: "Total Invoice Amount",
      field: "totalInvoiceAmount",
      width: 150,
      valueGetter: p => p.data["Total Invoice Amount"],
      sortable: true,
    },
  ]; 

  const creditNoteColumns: ColumnDefinition[] = [
    {
      headerName: "Action",
      field: "action",
      width: 150,
      cellRenderer: (params: any) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => openDrawer(params.data)}
        >
          View
        </Button>
      ),
    },
    // {
    //     headerName: "Description",
    //     field: "description",
    //     width: 150,
    //     valueGetter: p => p.data["Description"],
    //   },
    // {
    //   headerName: "Airline Name",
    //   field: "airlineName",
    //   width: 150,
    //   valueGetter: p => p.data["Airline Name"],
    // },
    // {
    //   headerName: "GSTIN of Supplier",
    //   field: "gstinSupplier",
    //   width: 150,
    //   valueGetter: p => p.data["GSTIN of Supplier"],
    // },
    // {
    //   headerName: "PAN",
    //   field: "pan",
    //   width: 150,
    //   valueGetter: p => p.data["PAN"],
    // },
    // {
    //   headerName: "Credit Note No",
    //   field: "creditNoteNo",
    //   width: 150,
    //   valueGetter: p => p.data["Credit Note No"],
    //   filter: true,
    // },
    // {
    //   headerName: "Credit Note Date",
    //   field: "creditNoteDate",
    //   width: 150,
    //   valueGetter: p => p.data["Credit Note Date"],
    // },
    {
      headerName: "Original Invoice No",
      field: "originalInvoiceNo",
      width: 150,
      valueGetter: p => p.data["Original Invoice No"],
    },
    {
      headerName: "Original Invoice Date",
      field: "originalInvoiceDate",
      width: 150,
      valueGetter: p => p.data["Original Invoice Date"],
    },
    {
      headerName: "Place of Supply",
      field: "placeOfSupply",
      width: 150,
      valueGetter: p => p.data["Place of Supply"],
    },
    // {
    //   headerName: "Reverse Charge",
    //   field: "reverseCharge",
    //   width: 150,
    //   valueGetter: p => p.data["Tax Is Payable On Reverse Charge: (Yes/No)"],
    // },
    {
      headerName: "Customer Name",
      field: "customerName",
      width: 150,
      valueGetter: p => p.data["Name"],
    },
    {
      headerName: "State",
      field: "state",
      width: 150,
      valueGetter: p => p.data["State and State Code"],
    },
    {
      headerName: "Recipient GSTIN",
      field: "recipientGstin",
      width: 150,
      valueGetter: p => p.data["GSTIN/Unique ID of Recipient"],
    },
    // {
    //   headerName: "Ticket / Document No",
    //   field: "ticketNo",
    //   width: 150,
    //   valueGetter: p => p.data["Ticket/ Document Number"],
    // },

    // {
    //   headerName: "HSN",
    //   field: "hsn",
    //   width: 150,
    //   valueGetter: p => p.data["HSN"],
    // },
    // {
    //   headerName: "Total Value",
    //   field: "totalValue",
    //   width: 150,
    //   valueGetter: p => p.data["Total Value"],
    // },
    // {
    //   headerName: "Other Taxes",
    //   field: "otherTaxes",
    //   width: 150,
    //   valueGetter: p => p.data["Other Taxes"],
    // },
    // {
    //   headerName: "Taxable Value",
    //   field: "taxableValue",
    //   width: 150,
    //   valueGetter: p => p.data["Taxable Value"],
    // },
    // {
    //   headerName: "Tax %",
    //   field: "taxPercent",
    //   width: 150,
    //   valueGetter: p => p.data["Tax %"],
    // },
    // {
    //   headerName: "Tax Amount",
    //   field: "taxAmount",
    //   width: 150,
    //   valueGetter: p => p.data["Tax Amount"],
    // },
    {
      headerName: "Total Credit Note Amount",
      field: "totalInvoiceAmount",
      width: 150,
      valueGetter: p => p.data["Total Invoice Amount"],
    },
  ];

  const importDoColumns: ColumnDefinition[] = [
    {
        headerName: "Action",
        field: "action",
        width: 150,
        cellRenderer: (params: any) => (
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => openDrawer(params.data)}
          >
            View
          </Button>
        ),
      },
    // {
    //   headerName: "Airline Name",
    //   field: "airlineName",
    //   width: 150,
    //   valueGetter: (p) => p.data["Airline Name"],
    // },
    // {
    //   headerName: "GSTIN of Supplier",
    //   field: "gstinSupplier",
    //   width: 150,
    //   valueGetter: (p) => p.data["GSTIN of Supplier"],
    // },
    // {
    //   headerName: "PAN",
    //   field: "pan",
    //   width: 150,
    //   valueGetter: (p) => p.data["PAN"],
    // },
    {
      headerName: "Invoice No",
      field: "invoiceNo",
      width: 150,
      valueGetter: (p) => p.data["Invoice No"],
    },
    {
        headerName: "Document Type",
        field: "TYPE",
        width: 150,
        valueGetter: (p) => p.data["TYPE"],
      },
    {
      headerName: "Invoice Date",
      field: "invoiceDate",
      width: 150,
      valueGetter: (p) => p.data["Invoice Date"],
    },
    {
      headerName: "Place of Supply",
      field: "placeOfSupply",
      width: 150,
      valueGetter: (p) => p.data["Place of Supply"],
    },
    {
        headerName: "Name",
        field: "name",
        width: 200,
        valueGetter: (p) => p.data["Name"],
      },
      {
        headerName: "Address",
        field: "address",
        width: 200,
        valueGetter: (p) => p.data["Address"],
      },
      {
        headerName: "State and State Code",
        field: "stateAndCode",
        width: 150,
        valueGetter: (p) => p.data["State and State Code"],
      },
      {
        headerName: "GSTIN/Unique ID of Recipient",
        field: "recipientGstin",
        width: 200,
        valueGetter: (p) => p.data["GSTIN/Unique ID of Recipient"],
      },
    //   {
    //     headerName: "Description",
    //     field: "description",
    //     width: 200,
    //     valueGetter: (p) => p.data["Description"],
    //   },
    //   {
    //     headerName: "HSN",
    //     field: "hsn",
    //     width: 150,
    //     valueGetter: (p) => p.data["HSN"],
    //   },
    //   {
    //     headerName: "Total Value",
    //     field: "totalValue",
    //     width: 150,
    //     valueGetter: (p) => p.data["Total Value"],
    //   },
    //   {
    //     headerName: "Taxable Value",
    //     field: "taxableValue",
    //     width: 150,
    //     valueGetter: (p) => p.data["Taxable Value"],
    //   },
    //   {
    //     headerName: "Tax %",
    //     field: "taxPercent",
    //     width: 100,
    //     valueGetter: (p) => p.data["Tax %"],
    //   },
    //   {
    //     headerName: "Tax Amount",
    //     field: "taxAmount",
    //     width: 150,
    //     valueGetter: (p) => p.data["Tax Amount"],
    //   },
      {
        headerName: "Total Invoice Amount",
        field: "totalInvoiceAmount",
        width: 200,
        valueGetter: (p) => p.data["Total Invoice Amount"],
      },
    ];

    const cargoColumns: ColumnDefinition[] = [

        {
            headerName: "Action",
            field: "action",
            width: 150,
            cellRenderer: (params: any) => (
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => openDrawer(params.data)}
              >
                View
              </Button>
            ),
          },
        // {
        //   headerName: "Airline Name",
        //   field: "airlineName",
        //   width: 150,
        //   valueGetter: (p) => p.data["Airline Name"],
        // },
        // {
        //   headerName: "GSTIN of Supplier",
        //   field: "gstinSupplier",
        //   width: 150,
        //   valueGetter: (p) => p.data["GSTIN of Supplier"],
        // },
        // {
        //   headerName: "PAN",
        //   field: "pan",
        //   width: 150,
        //   valueGetter: (p) => p.data["PAN"],
        // },
        {
          headerName: "Invoice No",
          field: "invoiceNo",
          width: 150,
          valueGetter: (p) => p.data["Invoice No"],
        },
        {
          headerName: "Invoice Date",
          field: "invoiceDate",
          width: 150,
          valueGetter: (p) => p.data["Invoice Date"],
        },
        {
          headerName: "Place of Supply",
          field: "placeOfSupply",
          width: 150,
          valueGetter: (p) => p.data["Place of Supply"],
        },
        {
            headerName: "Name",
            field: "name",
            width: 200,
            valueGetter: (p) => p.data["Name"],
          },
          {
            headerName: "Address",
            field: "address",
            width: 200,
            valueGetter: (p) => p.data["Address"],
          },
          {
            headerName: "State and State Code",
            field: "stateAndCode",
            width: 150,
            valueGetter: (p) => p.data["State and State Code"],
          },
          {
            headerName: "GSTIN/Unique ID of Recipient",
            field: "recipientGstin",
            width: 200,
            valueGetter: (p) => p.data["GSTIN/Unique ID of Recipient"],
          },
        //   {
        //     headerName: "Description",
        //     field: "description",
        //     width: 200,
        //     valueGetter: (p) => p.data["Description"],
        //   },
        //   {
        //     headerName: "HSN",
        //     field: "hsn",
        //     width: 150,
        //     valueGetter: (p) => p.data["HSN"],
        //   },
        //   {
        //     headerName: "Total Value",
        //     field: "totalValue",
        //     width: 150,
        //     valueGetter: (p) => p.data["Total Value"],
        //   },
        //   {
        //     headerName: "Taxable Value",
        //     field: "taxableValue",
        //     width: 150,
        //     valueGetter: (p) => p.data["Taxable Value"],
        //   },
        //   {
        //     headerName: "Tax %",
        //     field: "taxPercent",
        //     width: 100,
        //     valueGetter: (p) => p.data["Tax %"],
        //   },
        //   {
        //     headerName: "Tax Amount",
        //     field: "taxAmount",
        //     width: 150,
        //     valueGetter: (p) => p.data["Tax Amount"],
        //   },
          {
            headerName: "Total Invoice Amount",
            field: "totalInvoiceAmount",
            width: 200,
            valueGetter: (p) => p.data["Total Invoice Amount"],
          },
    ];

    const importDoRowData = importDoData.map((row: any) => ({
        ...row,
        pdf:
          IMPORT_DO_PDF_MAP[row["Invoice No"]] ||
          IMPORT_DO_PDF_MAP[row["Credit Note No"]],
      }));

      const cargoRowData = cargoData.map((row: any) => ({
        ...row,
        pdf: CARGO_PDF_MAP[row["Invoice No"]],
      }));
      
  
  const stats = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4 2C2.89 2 2 2.89 2 4V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H12.41C13.4943 22.6516 14.735 22.9972 16 23C17.8565 23 19.637 22.2625 20.9497 20.9497C22.2625 19.637 23 17.8565 23 16C22.9982 14.4939 22.5108 13.0286 21.61 11.8216C20.7093 10.6146 19.4433 9.7303 18 9.3V8L12 2H4ZM11 3.5L16.5 9H11V3.5ZM16 11C17.3261 11 18.5979 11.5268 19.5355 12.4645C20.4732 13.4021 21 14.6739 21 16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21C14.6739 21 13.4021 20.4732 12.4645 19.5355C11.5268 18.5979 11 17.3261 11 16C11 14.6739 11.5268 13.4021 12.4645 12.4645C13.4021 11.5268 14.6739 11 16 11ZM15 12V17L18.61 19.16L19.36 17.94L16.5 16.25V12H15Z"
            fill="#74003B"
          />
        </svg>
      ),
      label: "Number of Data Sent",
      value: 12,
    },

    {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 5.5C12.9283 5.5 13.8185 5.86875 14.4749 6.52513C15.1313 7.1815 15.5 8.07174 15.5 9C15.5 9.92826 15.1313 10.8185 14.4749 11.4749C13.8185 12.1313 12.9283 12.5 12 12.5C11.0717 12.5 10.1815 12.1313 9.52513 11.4749C8.86875 10.8185 8.5 9.92826 8.5 9C8.5 8.07174 8.86875 7.1815 9.52513 6.52513C10.1815 5.86875 11.0717 5.5 12 5.5ZM5 8C5.56 8 6.08 8.15 6.53 8.42C6.38 9.85 6.8 11.27 7.66 12.38C7.16 13.34 6.16 14 5 14C4.20435 14 3.44129 13.6839 2.87868 13.1213C2.31607 12.5587 2 11.7956 2 11C2 10.2044 2.31607 9.44129 2.87868 8.87868C3.44129 8.31607 4.20435 8 5 8ZM19 8C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11C22 11.7956 21.6839 12.5587 21.1213 13.1213C20.5587 13.6839 19.7956 14 19 14C17.84 14 16.84 13.34 16.34 12.38C17.2 11.27 17.62 9.85 17.47 8.42C17.92 8.15 18.44 8 19 8ZM5.5 18.25C5.5 16.18 8.41 14.5 12 14.5C15.59 14.5 18.5 16.18 18.5 18.25V20H5.5V18.25ZM0 20V18.5C0 17.11 1.89 15.94 4.45 15.6C3.86 16.28 3.5 17.22 3.5 18.25V20H0ZM24 20H20.5V18.25C20.5 17.22 20.14 16.28 19.55 15.6C22.11 15.94 24 17.11 24 18.5V20Z"
              fill="#74003B"
            />
          </svg>
        ),
        label: "Number of Invoices Generated",
        value: 12,
      },

  ];
  
  const invoiceRowData = invoiceData.map((row: any) => ({
    ...row,
    pdf: INVOICE_PDF_MAP[row["Invoice No"]],
  }));
  
  const creditNoteRowData = creditNoteData.map((row: any) => ({
    ...row,
    pdf: CREDIT_NOTE_PDF_MAP[row["Credit Note No"]],
  }));
  
  
  return (
    <div className="fk-generated-invoice">
    <div className="invoice-request-header">
        <div className="stats-section">
          {stats.map((stat, index) => (
            <StatCard
              key={index}
              icon={stat.icon}
              label={stat.label}
              value={stat.value}
              // color={stat.color}
            />
          ))}
        </div>
    </div>
      <Tabs defaultActiveKey="invoice">
        <TabPane tab="PAX Invoice" key="invoice">
        <div style={{ height: 400 }}>
            <CustomAgGrid
                columnDefs={invoiceColumns}
                rowData={invoiceRowData} 
                enableFilter
                enableSort
                enablePagination={false}
                enableCheckbox={false}
            />
        </div>
        </TabPane>

        <TabPane tab="PAX Credit Note" key="creditNote">
        <div style={{ height: 400 }}>
            <CustomAgGrid
            columnDefs={creditNoteColumns}
            rowData={creditNoteRowData}
            enableFilter
            enableSort
            enablePagination={false}
            enableCheckbox={false}
            />
        </div>
        </TabPane>
        <TabPane tab="Import DO" key="importDo">
      <div style={{ height: 400 }}>
        <CustomAgGrid
          columnDefs={importDoColumns}
          rowData={importDoRowData}
          enableFilter
          enableSort
          enablePagination={false}
          enableCheckbox={false}
        />
      </div>
    </TabPane>

    <TabPane tab="Cargo" key="cargo">
      <div style={{ height: 400 }}>
        <CustomAgGrid
          columnDefs={cargoColumns}
          rowData={cargoRowData}
          enableFilter
          enableSort
          enablePagination={false}
          enableCheckbox={false}
        />
      </div>
    </TabPane>
      </Tabs>

      <Drawer
        title="Document Preview"
        placement="right"
        width="40%"
        onClose={closeDrawer}
        open={drawerOpen}
        >
        {selectedRow && (
            <>
            {selectedRow.pdf ? (
                <iframe
                src={selectedRow.pdf}
                title="PDF Preview"
                width="100%"
                height="800px"
                style={{ border: "none", marginTop: 16 }}
                />
            ) : (
                <p style={{ color: "red" }}>PDF not found for this document</p>
            )}
            </>
        )}
        </Drawer>

    </div>
  );
};

export default FkGeneratedInvoice;
